<!-- <div class="row">
    <div class="col-sm-6">
        <div class="card ">
            <div class="card-body ">
                <p class="card-text text-muted">Site : <b>{{siteName}}</b></p>
                <p class="card-text text-muted">System : <b>{{systemName}}</b> </p>
                <p class="card-text text-muted">Employee : <b>{{employee}}</b> </p>
            </div>
        </div>
    </div>
    <div class="col-sm-6">
        <div class="card">
            <div class="card-body">
                <p class="card-text text-muted">Product : <b>{{product}}</b></p>
                <p class="card-text text-muted">Date From : <b>{{dateFrom}}</b> </p>
                <p class="card-text text-muted">Date To : <b>{{dateTo}}</b></p>
            </div>
        </div>
    </div>
</div> -->
<!-- <app-table-standard-layout *ngIf="columnSettings" [sortingArray]="sortingArray" [dataSource$]="values$" [title]="'Report'"
    [columnSettings]="columnSettings">
</app-table-standard-layout> -->

<div class="table-container mat-elevation-z8">

    <table mat-table [dataSource]="values$" matSort class="mat-elevation-z8">


        <ng-container *ngFor="let columnSetting of columnSettings" [matColumnDef]="columnSetting.columnId">
            <th class="gray" mat-header-cell *matHeaderCellDef mat-sort-header>
                {{columnSetting.name}}</th>
            <td mat-cell *matCellDef="let element" class="divider-cell"> {{ element[columnSetting.columnId] }} </td>
            <td mat-footer-cell *matFooterCellDef> {{ columnTotals[columnSetting.columnId] }} </td>

        </ng-container>


        <tr mat-header-row *matHeaderRowDef="displayedColumn()"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumn();"></tr>
        <tr  mat-header-row  *matFooterRowDef="displayedColumn()"></tr>

    </table>
</div> 
<!-- <ng-container *ngIf="forceLoading">
    <app-spinner-loading></app-spinner-loading>
</ng-container> -->